// extracted by mini-css-extract-plugin
export default {"general":"TeasersVersion2_general--MTL","teaser":"TeasersVersion2_teaser--Ied","skeletWithBullets":"TeasersVersion2_skeletWithBullets--uVV"};